import { ETAB_LAYOUTS } from "@etab/config";

import DashboardLayout from "./dashboard/Dashboard.layout.vue";
import NoLayout from "./No.layout.vue";
import PricingLayout from "./Pricing.layout.vue";
import StartupLayout from "./Startup.layout.vue";
import StepsLayout from "./Steps.layout.vue";
import SuccessLayout from "./Success.layout.vue";

/**
 * List of layout components with matching names
 */
export const layoutComponents = {
  [ETAB_LAYOUTS.dashboard]: DashboardLayout,
  [ETAB_LAYOUTS.default]: NoLayout,
  [ETAB_LAYOUTS.no]: NoLayout,
  [ETAB_LAYOUTS.pricing]: PricingLayout,
  [ETAB_LAYOUTS.startup]: StartupLayout,
  [ETAB_LAYOUTS.steps]: StepsLayout,
  [ETAB_LAYOUTS.success]: SuccessLayout,
};
